import axios from 'axios';
import { toast } from 'react-toastify';
import { config } from '../../config/envs';
import { generateTraceId } from './index';
import { mapJussubSubscription } from './subscriptionJussubMapper';
import { mapJusbillSubscription } from './subscriptionJusbillMapper';

const base = process.env.REACT_APP_API_URL;

export const getClientSubscriptionV2 = async (clientId) => {
  const response = await axios.get(`${base}/v2/subscriptions/${clientId}`, {
    headers: { 'x-trace-id': generateTraceId() },
  });
  return response.data;
};

// Prévia autoritativa da próxima cobrança (proxy para o JusSub): subtotal,
// descontos, itens e total — substitui o valor derivado (charged_amount/
// plan_amount) na tela de Financeiro. Exclusivo do JusSub. O admin informa o
// clientId para consultar a assinatura de outro cliente; sem ele, o backend usa
// o client do próprio usuário autenticado.
export const getNextCharge = async (subscriptionId, clientId) => {
  const response = await axios.get(
    `${base}/v2/subscriptions/${encodeURIComponent(subscriptionId)}/next-charge`,
    {
      params: clientId ? { client_id: clientId } : undefined,
      headers: { 'x-trace-id': generateTraceId() },
    },
  );
  return response.data;
};

const postSubscriptionAddonAction = async (action, subscriptionId, addonId) => {
  const response = await axios.post(
    `${base}/admin/v2/subscriptions/${encodeURIComponent(subscriptionId)}/addons/${encodeURIComponent(addonId)}/${action}`,
    undefined,
    {
      headers: { 'x-trace-id': generateTraceId() },
    },
  );
  return response.data;
};

export const cancelSubscriptionAddon = (subscriptionId, addonId) =>
  postSubscriptionAddonAction('cancel', subscriptionId, addonId);

export const reactivateSubscriptionAddon = (subscriptionId, addonId) =>
  postSubscriptionAddonAction('reactivate', subscriptionId, addonId);

const SUBSCRIPTION_MAPPERS_BY_PROVIDER = {
  jussub: mapJussubSubscription,
  jusbill: mapJusbillSubscription,
};

export const mapSubscriptionV2Response = (data) => {
  if (!data?.success) return null;

  const mapSubscription = SUBSCRIPTION_MAPPERS_BY_PROVIDER[data.provider];

  if (!mapSubscription) {
    console.error('Provider de assinatura não mapeado:', data.provider);
    toast.error('Não foi possível carregar os dados da assinatura do cliente.');
    return null;
  }

  return mapSubscription(data);
};

// Endpoint legado depende de a assinatura existir na base local; clientes só
// com assinatura no Jusbill não têm esse registro e recebem 404. O fallback
// v2 cancela direto no Jusbill, sem essa dependência.
const cancelSubscriptionV2 = async (clientId, reason, userId) => {
  const response = await axios.delete(
    `${config.app.adminBaseUrl}/clients/${clientId}/subscription`,
    {
      params: { reason_description: reason, from: `admin:${userId}` },
      headers: { 'x-trace-id': generateTraceId() },
    },
  );

  if (!response.data.success) {
    throw new Error(response.data.message || 'Erro ao cancelar assinatura.');
  }
};

export const cancelSubscription = async (clientId, userId, reason) => {
  let response;
  try {
    response = await axios.post(
      `${base}/subscription/cancel/${clientId}`,
      { values: { reason_description: reason, from: `admin:${userId}` } },
      { headers: { 'x-trace-id': generateTraceId() } },
    );
  } catch (error) {
    const status = error.response?.status;
    const isHttpError = Boolean(error.response) && (status < 200 || status >= 300);
    if (!isHttpError) throw error;
    return cancelSubscriptionV2(clientId, reason, userId);
  }

  if (!response.data.success) throw new Error('Erro ao cancelar assinatura.');
};
